<template>
    <el-tooltip 
        :popper-class="zIndex ? 'smr-tooltip smr-tooltip--index': 'smr-tooltip'"
        effect="dark" 
        :hide-after="2700"
        :content="content"
        :placement="position" 
        :open-delay="700"
        :disabled="mobile ? true: false"
        transition="el-fade-in-linear">
            <slot></slot>
    </el-tooltip>
</template>
<script>
import { mapGetters } from 'vuex';
    export default {
        props: {
            content: {
                type: String,
                default: '',
            },
            position: {
                type: String,
                default: 'left',
            },
            zIndex: { //increase z-index for options panel
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapGetters(['mobile']),
        }
    }
</script>

<style lang="scss">
.smr-tooltip {
    font-family: $font-family;
    font-weight: 400;
    box-shadow: $popup-shadow;
    background-color: $color-grey-dark !important;
    padding: 6px 12px;
    font-size: 14px;
    &--index {
        z-index: 100025 !important;
    }
    &[x-placement^=left] .popper__arrow {
        &:after {
            border-left-color: $color-grey-dark;
        }
    }
    &[x-placement^=left] .popper__arrow {
        border-left-color: $color-grey-dark;
    }
    &[x-placement^=right] .popper__arrow {
        &:after {
            border-right-color: $color-grey-dark;
        }
    }
    &[x-placement^=right] .popper__arrow {
        border-right-color: $color-grey-dark;
    }
    &[x-placement^=bottom] .popper__arrow {
        &:after {
            border-bottom-color: $color-grey-dark;
        }
    }
    &[x-placement^=bottom] .popper__arrow {
        border-bottom-color: $color-grey-dark;
    }
    &[x-placement^=top] .popper__arrow {
        &:after {
            border-top-color: $color-grey-dark;
        }
    }
    &[x-placement^=top] .popper__arrow {
        border-top-color: $color-grey-dark;
    }
}
</style>
